import { Link } from 'react-router';
import cookies from '../utils/cookies';
import ViewCartBtn from './ViewCartBtn';

export default function Navbar({ activePage }: { activePage: string }) {
  const showRecommended = cookies.get('prevProductIds') ? true : false;

  return (
    <>
      <div className={`navbar-wrap col-12 position-relative mb-4 mt-lg-3 ${!showRecommended ? 'd-none d-md-block' : ''}`}>
        <div className="view-cart-wrap position-absolute">
          <ViewCartBtn />
        </div>

        <ul className="nav nav-tabs my-0">
          {showRecommended && (
            <li className="nav-item">
              <Link
                className={`nav-link ${activePage === 'recommended' ? 'active' : ''}`}
                aria-current={activePage === 'recommended' ? 'page' : undefined}
                to="/recommended/"
              >
                Recommended
              </Link>
            </li>
          )}
          <li className="nav-item">
            <Link
              className={`nav-link ${activePage === 'full-catalog' ? 'active' : ''}`}
              aria-current={activePage === 'full-catalog' ? 'page' : undefined}
              to="/full-catalog/"
            >
              Full Catalog
            </Link>
          </li>
        </ul>
      </div>
    </>
  );
}
